import { basePaths } from 'automation-ui-canvas/constants/Routes';
import { WAIT_UNTIL } from 'automation-ui-action-features/constants/ActionTypes';
export const mapActionTypeToRoute = ({
  actionType
}) => {
  switch (actionType) {
    case WAIT_UNTIL:
      return basePaths.PLATFORM_FLOW_WAIT_UNTIL_ACTION;
    //
    // TODO: add more here as we unlock more data passing actions
    //
    default:
      return '';
  }
};